// noinspection JSUnusedGlobalSymbols
export interface GraphRoles {
    '@odata.nextLink': string;
    value: GraphRole[];
  }

export class GraphRole {
    // noinspection JSUnusedGlobalSymbols
    public id: string;
    // noinspection JSUnusedGlobalSymbols
    public description: string;
    // noinspection JSUnusedGlobalSymbols
    public displayName: string;
}
